import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import TrialPopup from './components/TrialPopup';
import ModernAlertHost from './components/ModernAlertHost';
import SessionIdleWatcher from './components/SessionIdleWatcher';
import SessionTimeoutModal from './components/SessionTimeoutModal';
import { TrialProvider } from './context/TrialContext';
import { UserProvider } from './context/UserContext';
import { permissionService } from './services/permissionService';
import { API_BASE, PORTAL_ID } from './utils/api';
import { applyThemeToDocument, getStoredTheme } from './utils/theme';

import './assets/fonts/local-fonts.css';
import './index.css';

export default function SalonAdminFlowLayout() {
  useEffect(() => {
    applyThemeToDocument(getStoredTheme());
  }, []);

  useEffect(() => {
    const orig = window.fetch.bind(window);
    window.fetch = (input, init = {}) => {
      const url = typeof input === "string" ? input : input?.url || "";
      if (API_BASE && typeof url === "string" && url.startsWith(API_BASE)) {
        const headers = new Headers(init.headers || {});
        headers.set("X-Naturals-Portal", PORTAL_ID);
        return orig(input, { ...init, headers, credentials: init.credentials || "include" });
      }
      return orig(input, init);
    };
    return () => {
      window.fetch = orig;
    };
  }, []);

  // Franchise partners keep the dashboard open for check-ins — no idle auto-logout.
  const enableIdleTimeout = !permissionService.isFranchise();

  return (
    <UserProvider>
      <TrialProvider>
        <TrialPopup />
        <ModernAlertHost />
        {enableIdleTimeout ? (
          <>
            <SessionIdleWatcher />
            <SessionTimeoutModal />
          </>
        ) : null}
        <Outlet />
      </TrialProvider>
    </UserProvider>
  );
}
